<div
  class="toast-container"
  [ngClass]="[
    'toast-' + type,
    hasTitle ? 'toast--with-title' : '',
    position ? 'toast-pos--' + position : '',
  ]"
>
  @if (hasTitle) {
    <div class="toast-top">
      <div class="toast-header">
        <mat-icon [fontIcon]="icon" class="icon-m outline"></mat-icon>
        <span class="toast-title">{{ title | translate }}</span>
      </div>
      <span class="message">{{ message | translate }}</span>
      <div class="toast-footer">
        <button class="close-button--text" data-fs-element="Toast-Button-Close-Text" (click)="close()">
          {{ 'RATING_POP_UP.CLOSE' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <mat-icon [fontIcon]="icon" class="icon-m outline"></mat-icon>
    <span class="message">
      <ng-container *ngIf="isTranslationKey(message); else plainText">
        {{ message | translate }}
      </ng-container>
      <ng-template #plainText>{{ message }}</ng-template>
    </span>
    <button *ngIf="showCloseButton" class="close-button" data-fs-element="Toast-Button-Close" (click)="close()">
      {{ 'HOME.TOAST.CLOSEBUTTON' | translate }}
    </button>
  }
</div>
